export enum AvailableTrialType {
  DISCOVERY = "DISCOVERY",
  NORMAL = "NORMAL",
  BOTH = "BOTH"
}
